import CrowdFundingCover, { I18N_CONTEXT } from './crowdfunding_cover'
import { getI18n } from 'client/i18n'
import { reduxForm } from 'redux-form'
import { DESCRIPTION_LENGTH } from 'shared/lengths'
import { GN_DISCLAIMERS } from 'shared/shared_consts'
import formUtils from 'lib/form_utils'
import { length } from 'lib/validators'
import { push } from 'react-router-redux'

import { NEW_CAMPAIGN_ID, setData } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { getCategoryDefaultCover } from 'client/lib/category'

const i18n = getI18n(I18N_CONTEXT)

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  // only set the prop if no category is defined.
  const defaultCategoryCover = getCategoryDefaultCover(state, campaign.category)
  return {
    isAndroid:
      state.device_info.isMobile && state.device_info.deviceOS === 'Android',
    defaultCategoryCover,
    initialValues: {
      backgroundImage: campaign.background_image,
      backgroundPan: campaign.background_pan,
      backgroundImageFilename: campaign.background_image_filename,
    },
    charity: campaign.charity,
    termsAndConditionLink:
      GN_DISCLAIMERS[state.country.country_code].termsAndConditions,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setData: ({
      background_image,
      background_image_filename,
      background_pan,
    }) => {
      dispatch(
        setData(NEW_CAMPAIGN_ID, {
          background_image,
          background_image_filename,
          background_pan,
        })
      )
    },
    submit: pathname => {
      return dispatch(push({ pathname }))
    },
  }
}

export default reduxForm(
  {
    form: 'create_description',
    destroyOnUnmount: false,
    fields: [
      'description',
      'backgroundImage',
      'backgroundImageFilename',
      'backgroundPan',
    ],
    touchOnBlur: false,
    touchOnChange: true,
    validate: length(
      'description',
      DESCRIPTION_LENGTH,
      i18n('description_too_long', {
        maxLength: DESCRIPTION_LENGTH,
      })
    ),
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(CrowdFundingCover))
